let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7xNiZ")).then(() => parcelRequire('cB5tR'));